import React from 'react';
import { Image } from 'react-native-web';
import { Android } from '../../../../utils/DictionaryManagementUtils';
import { img_scr_onboarding_03_c_and, img_scr_onboarding_03_c_ios } from '../../../../utils/ImagesManagementUtils';
//= ========================================================================

const LetterKeyboardImage = ({
  globJSON,
  simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    phoneImage: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      position: 'absolute',
      backgroundColor: simPlatform === Android
        ? '#f0f5f9'
        : colors.app_background_color,
    },
  };
  return (
    <Image
      fadeDuration={0}
      style={[
        myStyles.phoneImage,
        { backgroundColor: colors.app_background_color },
      ]}
      source={simPlatform === Android ? img_scr_onboarding_03_c_and : img_scr_onboarding_03_c_ios}
    />
  );
};
export default LetterKeyboardImage;
